"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HelpButton;
var _collapseButton = _interopRequireDefault(require("./collapse-button"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function HelpButton({
  children,
  ...collapseButtonProps
}) {
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_collapseButton.default, _extends({
    showName: "Show Help",
    hideName: "Hide Help"
  }, collapseButtonProps), /*#__PURE__*/_react.default.createElement("div", {
    className: "card card-info card-block"
  }, children)));
}